import { deepMerge } from './utils';
import { base } from './themes';

export var defaultProps = {
  theme: base
};

export var extendDefaultTheme = function extendDefaultTheme(theme) {
  defaultProps.theme = deepMerge(base, theme);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/node_modules/grommet-icons/es6/default-props.js
// module id = 374
// module chunks = 0